var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnarchive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.833252 10C2.27492 6.34167 5.83325 3.75 9.99992 3.75C14.1666 3.75 17.7249 6.34167 19.1666 10C17.7249 13.6583 14.1666 16.25 9.99992 16.25C5.83325 16.25 2.27492 13.6583 0.833252 10ZM5.83325 10C5.83325 12.3 7.69992 14.1667 9.99992 14.1667C12.2999 14.1667 14.1666 12.3 14.1666 10C14.1666 7.7 12.2999 5.83333 9.99992 5.83333C7.69992 5.83333 5.83325 7.7 5.83325 10ZM7.49992 10C7.49992 8.61667 8.61658 7.5 9.99992 7.5C11.3833 7.5 12.4999 8.61667 12.4999 10C12.4999 11.3833 11.3833 12.5 9.99992 12.5C8.61658 12.5 7.49992 11.3833 7.49992 10Z",
    fill: "#3A4861"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnarchive);
export default __webpack_public_path__ + "static/media/Unarchive.55dd33a7c46c5590c76b4a012ad3bd6b.svg";
export { ForwardRef as ReactComponent };